<template>
  <div class="relato">
    <!-- Modal Overlay -->
    <div v-if="modalVisivel" class="modal-overlay"></div>
    <div class="header-container">
      <h1 class="title-relato">Relatos - Autoatendimento</h1>
      <div class="search-bar">
        <input
          type="text"
          v-model="filtroPesquisa"
          placeholder="Buscar relatos..."
          @input="filtrarRelatos"
        />
        <span class="search-icon">
          <i class="fas fa-search"></i>
        </span>
      </div>
    </div>

    <div class="table-container">
  <table class="relatos-table">
    <thead>
  <tr>
    <th v-for="(coluna, index) in colunas" :key="index" :style="{ width: coluna.largura + 'px' }">
      {{ coluna.label }}
      <span class="resizer" @mousedown="iniciarResize($event, index)"></span>
    </th>
  </tr>
</thead>



<tbody>
  <tr v-for="relato in relatosFiltrados" :key="relato.id">
    <td v-for="(coluna, index) in colunas" 
        :key="index" 
        :style="{ width: coluna.largura + 'px' }"
        :class="coluna.chave === 'acoes' ? 'acao-coluna' : ''">
      <template v-if="coluna.chave === 'acoes'">
        <!-- 🔥 Exibe o botão se for a coluna "Ações" -->
        <button @click="abrirModalEdicao(relato)" class="edit-button">
          <i class="fas fa-edit"></i>
        </button>
      </template>
      <template v-else>
        <!-- 🔥 Exibe o texto normalmente para outras colunas -->
        <span class="text-truncate">{{ relato[coluna.chave] }}</span>
      </template>
    </td>
  </tr>
</tbody>

  </table>
</div>


    <!-- Modal de Edição -->
    <ModalEdit
      v-if="modalVisivel"
      :isVisible="modalVisivel"
      :relatoData="relatoSelecionado"
      :userName="nomeDoUsuarioLogado"
      @salvo="atualizarRelato"
      @fechar="modalVisivel = false"
    />
  </div>
</template>


<script>
import axios from 'axios';
import ModalEdit from '../components/ModalEdit.vue';

export default {
  components: {
    ModalEdit,
  },
  data() {
    return {
      relatos: [],
      filtroPesquisa: "",
      relatosFiltrados: [],
      colunas: [
      { label: "Ações", chave: "acoes", largura: 100 },
      { label: "Nome do Cliente", chave: "nome_cliente", largura: 150 },
      { label: "CPF do Cliente", chave: "cpf_cliente", largura: 120 },
      { label: "Telefone do Cliente", chave: "fone_cliente", largura: 140 },
      { label: "Placa do Veículo", chave: "placa_veiculo", largura: 130 },
      { label: "CEP do Veículo", chave: "cep_veiculo", largura: 130 },
      { label: "Motivo do Contato", chave: "motivo_contato", largura: 160 },
      { label: "Problema", chave: "problema", largura: 200 },
      { label: "Relato do Problema", chave: "relato_problema", largura: 250 },
      { label: "Atendente", chave: "atendente", largura: 120 },
      { label: "Protocolo", chave: "protocolo", largura: 130 },
      { label: "Criado em", chave: "criado_em", largura: 150 },
    ],
      colunaRedimensionando: null,
      larguraInicial: 0,
      posicaoInicialX: 0,
      modalVisivel: false,
      relatoSelecionado: null,
      socket: null,
      nomeDoUsuarioLogado: localStorage.getItem('nome_usuario') || 'Usuário Desconhecido',
    };
  },
  created() {
    this.obterRelatos();
  },
  mounted() {
    this.socket = new WebSocket("wss://api-autoatendimento.nextcomm.tech/ws");
    //this.socket = new WebSocket("ws://127.0.0.1:19000/ws");
    this.socket.onmessage = () => {
      this.obterRelatos();
    };
  },
  beforeDestroy() {
    if (this.socket) {
      this.socket.close();
    }
  },
  methods: {
  iniciarResize(event, index) {
    this.colunaRedimensionando = index;
    this.larguraInicial = this.colunas[index].largura;
    this.posicaoInicialX = event.clientX;

    document.addEventListener("mousemove", this.redimensionar);
    document.addEventListener("mouseup", this.finalizarResize);
  },
  redimensionar(event) {
    if (this.colunaRedimensionando !== null) {
      const diferenca = event.clientX - this.posicaoInicialX;
      this.colunas[this.colunaRedimensionando].largura = Math.max(
        this.larguraInicial + diferenca,
        50 // Define um tamanho mínimo
      );
    }
  },
  finalizarResize() {
    this.colunaRedimensionando = null;
    document.removeEventListener("mousemove", this.redimensionar);
    document.removeEventListener("mouseup", this.finalizarResize);
  }, // ✅ Corrigida a vírgula aqui

  async obterRelatos() {
    try {
      const response = await axios.get('https://api-autoatendimento.nextcomm.tech/api/v1/relatos/todos');
      //const response = await axios.get("http://127.0.0.1:19000/api/v1/relatos/todos");
      this.relatos = response.data;
      this.relatosFiltrados = this.relatos;
    } catch (error) {
      console.error("Erro ao obter relatos:", error);
    }
  },
  filtrarRelatos() {
    const termo = this.filtroPesquisa.toLowerCase();
    this.relatosFiltrados = this.relatos.filter((relato) =>
      Object.values(relato).some(
        (valor) => valor?.toString().toLowerCase().includes(termo)
      )
    );
  },
  abrirModalEdicao(relato) {
    console.log("Abrindo modal com relato:", relato);
    this.relatoSelecionado = { ...relato };
    this.modalVisivel = true;
  },
  async atualizarRelato(dadosAtualizados) {
    this.modalVisivel = false;
    const index = this.relatos.findIndex((relato) => relato.id === dadosAtualizados.id);
    if (index !== -1) {
      this.$set(this.relatos, index, dadosAtualizados);
      this.filtrarRelatos();
    } else {
      console.error("Erro: Relato não encontrado para atualização.");
    }
  }
}
};
</script>

<style scoped>
.relato {
  font-family: 'Roboto', sans-serif;
  background-color: #f4f6f8;
  color: #333;
  padding: 20px;
  border-radius: 8px;
}

/* Centraliza o botão na coluna "Ações" */
.relatos-table td.acao-coluna {
  text-align: center; /* Centraliza o conteúdo horizontalmente */
  vertical-align: middle; /* Centraliza verticalmente */
}

.header-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
}

.title-relato {
  color: #1a472a;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 10px;
}

.search-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 600px;
  position: relative;
  margin-bottom: 20px;
}

.search-bar input {
  width: 100%;
  padding: 10px 40px 10px 15px;
  border: 2px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  outline: none;
  transition: border-color 0.3s;
  color: #1a472a;
  background-color: #fff;
}

.search-bar input:focus {
  border-color: #1a9850;
}

.search-icon {
  position: absolute;
  right: 10px;
  color: #888;
  font-size: 18px;
  pointer-events: none;
}

/* 🛠️ Scroll horizontal se a tabela for maior que a tela */
.table-container {
  max-height: 70vh;
  overflow-x: auto;
  overflow-y: auto;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* 🛠️ Ajuste dinâmico das colunas e truncamento de texto */
.relatos-table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
  font-size: 12px;
  font-family: 'Roboto', sans-serif;
  table-layout: fixed; /* 🔥 Permite redimensionamento correto */
}

/* 🛠️ Garante que o cabeçalho fique fixo no topo */
.relatos-table thead th {
  background-color: #1a472a;
  color: white;
  padding: 10px;
  border-bottom: 1px solid #ddd;
  font-weight: 600;
  text-transform: uppercase;
  position: sticky;
  top: 0;
  z-index: 10;
  font-size: 12px;
  white-space: nowrap;
  border-right: 2px solid white;
}

/* 🛠️ Redimensionamento e truncamento de texto nas células */
.relatos-table th, .relatos-table td {
  white-space: nowrap; /* Mantém o conteúdo em uma linha */
  overflow: hidden;
  text-overflow: ellipsis; /* 🔥 Adiciona os "..." */
  padding: 10px;
  border-bottom: 1px solid #eee;
  color: #555;
}

/* 🛠️ Ajusta os botões dentro da célula de ações */
.action-column {
  text-align: center;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

/* 🛠️ Melhora a experiência ao interagir com os botões */
.edit-button {
  background: none;
  border: none;
  color: #1a472a;
  cursor: pointer;
  font-size: 16px;
  transition: color 0.3s;
}

.edit-button:hover {
  color: #1a9850;
}

/* 🔥 Ajuste para permitir redimensionamento das colunas */
th {
  position: relative;
  user-select: none;
}

/* 🔥 Puxador para redimensionar colunas */
.resizer {
  position: absolute;
  right: 0;
  top: 0;
  width: 5px;
  height: 100%;
  cursor: col-resize;
  background-color: transparent;
  z-index: 10;
}

.resizer:hover {
  background-color: rgba(0, 0, 0, 0.3);
}

/* 🛠️ Alterna a cor de fundo para melhor visualização */
.relatos-table tr:nth-child(even) {
  background-color: #f9f9f9;
}

.relatos-table tr:hover {
  background-color: #eef7f1;
  transition: background-color 0.2s;
}
</style>
